import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'

export const NOTIFY_USER_ACTION = (msisdn) => `/msisdn/${msisdn}/acao`
export const GENERATOR_OTP = (cpf, msisdn) => `/v2/cliente/${onlyNumbers(cpf)}/${onlyNumbers(msisdn)}/gerarotp`
export const VALIDATE_USER_AND_SELECT_PLAN = () => '/v2/cliente/validar'
export const VALIDATE_USER_AND_SELECT_PLAN_WITH_OTP = () => '/v2/cliente/validar/otp'
export const VALIDATE_USER_AND_PLAN_COMPATIBILITY = (msisdn, planoId) => `/cliente/${onlyNumbers(msisdn)}/plano/${planoId}/validar`
export const SWITCH_OFFER = (cpf, msisdn, offerId) => `/cliente/${onlyNumbers(cpf)}/${onlyNumbers(msisdn)}/plano/${offerId}/trocar`
export const AUTHENTICATE = () => '/promotor/autenticar'
export const FETCH_CARDS = (msisdn) => `/cliente/${onlyNumbers(msisdn)}/cartoes`
export const FETCH_CURRENT_PLAN = (msisdn) => `/cliente/${onlyNumbers(msisdn)}/plano`
export const VALIDATE_USER_BEAUTH = (code) => `/v2/beauth/${code}`
